
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/we-strive-for-inovations",
      function () {
        return require("private-next-pages/about-us/we-strive-for-inovations/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/we-strive-for-inovations"])
      });
    }
  